import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(Backend) // Loads translations from JSON files
  .use(LanguageDetector) // Detects browser language
  .use(initReactI18next) // Integrates with React
  .init({
    fallbackLng: "en", // Default language if detection fails
    debug: true, // Enables logging in the console
    interpolation: {
      escapeValue: false, // React already handles XSS
    },
    backend: {
      loadPath: "/locales/{{lng}}.json", // Location of translation files
    },
    detection: {
      order: ["querystring", "cookie", "localStorage", "navigator", "htmlTag"],
      caches: ["localStorage", "cookie"], // Cache the language in browser storage
    },
  });

export default i18n;
